// removed by extract-text-webpack-plugin
module.exports = {"root":"home--root--2MI2GqFt organization-home--root--29mpR9MJ","grid-container":"home--grid-container--1WwKUONb home--grid-container--3c3JLjRI","gridContainer":"home--grid-container--1WwKUONb home--grid-container--3c3JLjRI","message":"home--message--3eQXQtr_ home--message--9FSspPIv"};


//////////////////
// WEBPACK FOOTER
// ./views/lado-a-lado/multiplier/home/styles.css
// module id = ./views/lado-a-lado/multiplier/home/styles.css
// module chunks = 0